import { render, staticRenderFns } from "./EnableEdit.vue?vue&type=template&id=5212acab&"
import script from "./EnableEdit.vue?vue&type=script&lang=js&"
export * from "./EnableEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports